<template>
  <div class="home" v-if="client">
    <img @click="goTo('/')" class="logo" :src="client.logo" />
    <div
      class="audio"
      v-if="client.available_homes_video_audio"
      @click="muted = !muted"
    >
      <img v-if="muted" src="@/assets/img/volume.svg" />
      <img v-if="!muted" src="@/assets/img/mute.svg" />
    </div>
    <video
      :src="
        client.available_homes_video
          ? client.available_homes_video
          : require('@/assets/img/available_homes.mp4')
      "
      autoplay
      loop
      :muted="muted"
    ></video>
    <div class="text">
      <h1>Available Homes</h1>
      <p>
        Explore all home options and ask a team member how you can begin living
        in a community with infinite possibilities.
      </p>
    </div>
    <div class="dark"></div>
    <div class="choices">
      <div class="choice" @click="goTo('/newhomes')">
        <img src="@/assets/img/new_home.svg" />
        <h2>New Homes</h2>
      </div>
      <div class="choice" @click="goTo('/legacyhomes')">
        <img src="@/assets/img/home.svg" />
        <h2>Legacy Homes</h2>
      </div>
      <div class="choice" @click="goTo('/build')">
        <img src="@/assets/img/build_home.svg" />
        <h2>Build a Home</h2>
      </div>
    </div>
  </div>
</template>

<script>
import { db, functions, analytics } from "@/config/firebaseInit";
import QrcodeVue from "qrcode.vue";

export default {
  name: "home",
  components: {
    QrcodeVue,
  },
  data() {
    return {
      isMobile: false,
      client: this.$store.state.client,
      user: this.$store.state.user,
      muted: true,
    };
  },
  mounted() {},
  async created() {},
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.home {
  height: 100vh;
  width: 100vw;
}

.audio {
  position: fixed;
  top: 50px;
  right: 50px;
  height: 100px;
  width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 100%;
  z-index: 9;
  img {
    height: 30px;
    filter: brightness(0) invert(1);
  }
}

.dark {
  position: fixed;
  height: 100%;
  width: 100%;
  background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 1));
  bottom: 0;
  left: 0;
  z-index: 1;
}

.choices {
  width: 100%;
  position: fixed;
  bottom: 75px;
  display: flex;
  justify-content: center;
  z-index: 5;
  .choice {
    display: flex;
    align-items: center;
    padding: 30px 40px;
    margin: 30px 15px;
    width: 400px;
    background: rgba(255, 255, 255, 0.4);
    img {
      filter: brightness(0) invert(1);
      height: 50px;
      margin-bottom: 0;
      opacity: 0.5;
      margin-right: 20px;
    }
    h2 {
      margin: 0;
      font-size: 26px;
      text-transform: uppercase;
    }
  }
}

.text {
  position: fixed;
  top: 0;
  left: 0;
  width: 800px;
  height: 100%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 4;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  h1 {
    font-size: 75px;
    margin-bottom: 30px;
    margin-top: -150px;
  }
  p {
    color: white;
    font-size: 25px;
  }
}

.logo {
  position: absolute;
  transform: none;
  left: 100px;
  width: 300px;
  margin-top: 50px;
  z-index: 2;
}
</style>
